<template>
  <div class="language-selector">
    <button 
      class="language-btn" 
      :class="{ active: language === 'en' }" 
      @click="setLanguage('en')"
    >
      EN
    </button>
    <span class="divider">|</span>
    <button 
      class="language-btn" 
      :class="{ active: language === 'et' }" 
      @click="setLanguage('et')"
    >
      ET
    </button>
  </div>
</template>

<script>
import { useLanguageStore } from '../stores/language'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

export default {
  name: 'LanguageSelector',
  setup() {
    const languageStore = useLanguageStore()
    const { language } = storeToRefs(languageStore)
    const { setLanguage } = languageStore
    const { locale } = useI18n()

    // Function to change language
    const changeLanguage = (lang) => {
      setLanguage(lang)
      locale.value = lang
    }

    return {
      language,
      setLanguage: changeLanguage
    }
  }
}
</script>

<style lang="scss" scoped>
.language-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  .language-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    font-weight: 500;
    color: var(--color-text);
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--color-primary);
    }
    
    &.active {
      color: var(--color-primary);
      font-weight: 700;
    }
  }
  
  .divider {
    color: var(--color-text-light);
  }
}
</style>